import { Icon, Modal, spacing, Text } from '@scality/core-ui';
import { Box, Button } from '@scality/core-ui/dist/next';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useChatHistory } from '../../hooks/useChatHistory';

const CLEAR_CACHE_TOOLTIP = { overlay: 'Clear conversation history' };
const NO_CONVERSATION_HISTORY_TOOLTIP = {
  overlay: 'No conversation history to clear',
};

const SidebarFooterBox = styled.div`
  margin: ${spacing.r8};
  margin-top: auto;
  padding-top: ${spacing.r8};
  border-top: 1px solid ${(props) => props.theme.backgroundLevel4};
  font-size: 12px;
  color: ${(props) => props.theme.textSecondary};
`;

const SidebarModalFooter: React.FC<{
  onClose: () => void;
  onSubmit: () => void;
}> = ({ onClose, onSubmit }) => {
  return (
    <Box display="flex" justifyContent="end" gap={spacing.r8}>
      <Button variant="outline" onClick={onClose} label="Cancel" />
      <Button variant="danger" onClick={onSubmit} label="Delete" />
    </Box>
  );
};

export const SidebarFooter: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  const { chatHistory, clearCache } = useChatHistory();
  const handleClearCache = useCallback(() => {
    clearCache();
    closeModal();
  }, []);

  const isDisabled = chatHistory.length === 0;

  return (
    <SidebarFooterBox>
      <Box display="flex" flexDirection="column" alignItems="center" gap={spacing.r2}>
        <Text variant="Small">Your conversation history is always stored locally on your device.</Text>
        <Text variant="Small">Clearing your cache will erase the history.</Text>
      </Box>

      <Box paddingBottom={spacing.r16} paddingTop={spacing.r8}>
        <Button
          icon={<Icon name="Deletion-marker" />}
          variant="danger"
          onClick={openModal}
          tooltip={isDisabled ? NO_CONVERSATION_HISTORY_TOOLTIP : CLEAR_CACHE_TOOLTIP}
          disabled={isDisabled}
        />
      </Box>
      <Modal
        isOpen={isOpen}
        title="Clear conversation history ?"
        footer={<SidebarModalFooter onClose={closeModal} onSubmit={handleClearCache} />}
      >
        <Text>
          Your conversation history is stored locally on your device.
          <br />
          Clearing your cache will permanently delete all conversations and they cannot be recovered.
        </Text>
      </Modal>
    </SidebarFooterBox>
  );
};
